<div *ngIf="!this.teCuidamosSavia">
  <div class="ion-text-center">
    <img src="assets/images/tecuidamos/bannerregisterpresentation.png" />
  </div>

  <div class="content-margin-top ion-text-center">
    <div class="mapfre-fs-m-r dark mapfre-fw-300">{{
      'TECUIDAMOS.SIGNUP.TEXT1' | translate
    }}</div>
  </div>
  <div class="content-margin-vertical ion-text-center">
    <div class="mapfre-fs-xs-r medium-dark">{{
      'TECUIDAMOS.SIGNUP.TEXT2' | translate
    }}</div>
  </div>
  <ion-button [ngStyle]="{'width': '60%', 'margin': '0 auto'}" color="primary" expand="block" (click)="onClicked()">
    {{ 'TECUIDAMOS.SIGNUP.SIGNUPBUTTON' | translate }}
  </ion-button>
</div>

<div *ngIf="this.teCuidamosSavia" class="savia">
  <div class="mapfre-fw-500 mapfre-fs-xl mapfre-mb-xsm savia__title">
    {{ 'TECUIDAMOS.TC_PRESENTATION.WELCOME' | translate: {user: user?.name} | titlecase}}
  </div>
  <div class="mapfre-fw-400 grey-secondary mapfre-fs-s mapfre-mb-m savia__title">
    {{ 'TECUIDAMOS.TC_PRESENTATION.WELCOME_TEXT' | translate}}
  </div>

  <div class="savia__directAccess">
    <div class="savia__box savia__directAccess--box">
      <div class="savia__directAccess--img df jc-c ai-c">
        <img src="assets/images/tecuidamos/savingAndClovers.svg" alt="icon"/>
      </div>
      <div class="mapfre-fw-400 mapfre-fs-xxs-r medium-dark savia__directAccess--text">
        {{ 'TECUIDAMOS.TC_PRESENTATION.SAVING_AND_CLOVERS' | translate }}
      </div>
    </div>
    <div class="savia__box savia__directAccess--box">
      <div class="savia__directAccess--img df jc-c ai-c">
        <img src="assets/images/tecuidamos/consultantsAndExperts.svg" alt="icon"/>
      </div>
      <div class="mapfre-fw-400 mapfre-fs-xxs-r medium-dark savia__directAccess--text">
        {{ 'TECUIDAMOS.TC_PRESENTATION.CONSULTANTS_AND_EXPERTS' | translate }}
      </div>
    </div>
    <div class="savia__box savia__directAccess--box">
      <div class="savia__directAccess--img df jc-c ai-c">
        <img src="assets/images/tecuidamos/raffle.svg" alt="icon"/>
      </div>
      <div class="mapfre-fw-400 mapfre-fs-xxs-r medium-dark savia__directAccess--text">
        {{ 'TECUIDAMOS.TC_PRESENTATION.RAFFLES' | translate }}
      </div>
    </div>
  </div>

  <ion-button
    color="primary"
    class="savia__teCuidamos mapfre-fw-500 mapfre-fs-xs-r"
    (click)="onOpenSaviaRegisterTecuidamos()"
  >
    {{ 'TECUIDAMOS.TC_PRESENTATION.SUBSCRIBE' | translate}}
  </ion-button>
</div>
